<template>
    <div style="background-color: #FAF9F6;" :style="isDesktop() && !selected ? 'padding-bottom: 320px': '50px'">

        <TaxaPodFetestiNavigation></TaxaPodFetestiNavigation>

        <Steps :current-page="2"></Steps>

        <div class="section d-flex justify-content-center">
            <div class="container-medium purchase-wrapper">
                <div class="text-center pt-2">
                    <Heading v-if="category" :title="$t('buy_toll')" :routeName="'cart'" :alignment="'text-center'"></Heading>
                    <p class="pt-3"><span class="main-text">{{ $tc('step', 2) }}: {{ $t('choose_passings_number') }}</span></p>
                </div>
            </div>
        </div>
        <div class="container container-medium">
            <div class="auto-rov-catA">
                <div class="d-flex align-center" v-if="category && icons">
                    <div class="icon cat-icon m-0" :class="icons[(category.id-1)].icon" alt=""></div>
                    <div class="txt"><span v-html="category.desc"></span> / {{capitalize($t('tollWord', 3))}} {{ category.title }}</div>
                </div>
            </div>
        </div>
        <div class="container container-medium mt-3" v-if="category && !loading">
            <div class="row py-3">
                <div class="col-lg-4 col-md-4 col-xs-12 col-12" :class="isMobile() ? 'mb-3' : ''" v-for="(item, key) in category.prices" :key="key">
                    <div class="card card-pointer" :class="[{'card-primary': passes == key && selected}]"
                        @click="choosePasses(key)"
                        v-scroll-to="{
                            el: '.form-wrapper',
                            offset: -92, // -- 92px is the height of the fixed header
                        }">
                        <div class="elipse-complete position-absolute margin-minus" v-if="passes == key && selected">
                            <div class="icon v-icon"></div>
                        </div>
                        <span class="number-of-passes">{{item.valability.quantity}} {{$tc('passing', item.valability.quantity)}}</span>
                        <p class="card-text"><strong>{{item.value_ron}} {{ $tc('currency', item.value_ron) }}</strong></p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container container-xs no-padding-mobile" v-if="form_visible">
            <div id="form-1">
                <template v-if="!loading">
                    <template v-if="!vehicle">
                        <div>
                            <div class="form-group p-relative">
                                <label>{{ $t('label_license_plate') }}</label>
                                <span v-if="errorMsgs.plateNo" class="invalid-feedback">
                                    {{errorMsgs.plateNo}}
                                </span>
                                <input type="text" dusk="plate-nr-toll" class="form-control" @keydown.38.prevent @keydown.40.prevent :class="{'has-error': errorMsgs.plateNo}" :value="plateNo" @input="e => plateNo = e.target.value">
                                <autocomplete v-if="isLoggedIn && plateNo && showAutocomplete" :type="'tpf'" :search="plateNo" @destroy="destroyAutocomplete" @choose="setSearchedVehicle"></autocomplete>
                            </div>
                            <div class="form-group">
                                <label>{{ $t('label_chasis_number') }}</label>
                                <span v-if="errorMsgs.chasisNo" class="invalid-feedback">
                                    {{errorMsgs.chasisNo}}
                                </span>
                                <input type="text" dusk="chasisNo" class="form-control" :class="{'has-error': errorMsgs.chasisNo}" v-model="chasisNo">
                            </div>
                            <div class="form-group" v-if="countries">
                                <label for="taraInmatriculare">{{ $t('label_registration_country') }}</label>
                                <select class="form-control" id="taraInmatriculare" v-model="country" >
                                    <option :key="key" v-for="(c, key) in countries" :value="c.id">{{c.country}}</option>
                                </select>
                            </div>
                            <div class="form-group mb-3">
                                <label>{{ $t('label_motif') }} ({{ $t('label_optional_field') }})</label>
                                <input type="text" v-model="reason" class="form-control">
                            </div>
                        </div>
                    </template>
                    <template v-if="vehicle">
                        <div class="form-group" v-if="noChasisOnLoad">
                            <label>{{ $t('label_chasis_number') }}</label>
                            <span v-if="errorMsgs.chasisNo" class="invalid-feedback">
                                {{errorMsgs.chasisNo}}
                            </span>
                            <input type="text" class="form-control" :class="{'has-error' : errorMsgs.chasisNo}" v-model="chasisNo">
                        </div>
                        <div class="mb-3">
                            <AddProductForVehicle :vehicle="vehicle" :type="'toll'" :hide-btn="true"></AddProductForVehicle>
                        </div>
                    </template>
                    <div class="form-group">
                        <label class="sms-notification">
                            <input type="checkbox" v-model="sms_confirm_notification">
                            {{ $tc('sms_confirm_notification_peaj', Math.ceil(getSmsSetting.value), { 'price': getSmsSettingMessage() }) }}
                        </label>
                    </div>
                </template>
            </div>
        </div>

        <div class="container container-xs" v-if="selected">
            <div class="action-button action-button-big-desktop d-flex justify-content-end" v-if="!loading">
                <button type="submit" dusk="add-to-desktop-cart" class="btn btn-purple" @click="addToCart()">
                    <template v-if="!getEditProduct">
                        {{ $t('continue') }}
                    </template>
                    <template v-else>
                        {{ $t('continue') }}
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'
import Steps from './snippets/Steps.vue'
import CartSummary from './order/CartSummary.vue'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import TaxaPodFetestiNavigation from './TaxaPodFetestiNavigation.vue'
import AddProductForVehicle from './snippets/AddProductForVehicle.vue'
import Autocomplete from './snippets/Autocomplete.vue'

export default {
    name: 'TollCategory',
    components: {
        CartSummary,
        Heading,
        TaxaPodFetestiNavigation,
        Steps,
        AddProductForVehicle,
        Autocomplete
    },
    props: ['carId', 'id'],
    data: function() {
        return {
            form_visible: false,
            selected: false,
            category_key: 0,
            passes: 0,
            plateNo: '',
            chasisNo: '',
            country: 1,
            reason: '',
            errorMsgs: {
                plateNo: '',
                chasisNo: '',
            },
            loading: false,
            noChasisOnLoad: false,
            destAutocomplete: false,
            showAutocomplete: true,
            sms_confirm_notification: 0
        }
    },
    computed: {
        ...mapState('vehicles', [
            'vehicle'
        ]),

        ...mapState('tollCategories', [
            'category',
            'icons'
        ]),

        ...mapState('countries', [
            'countries'
        ]),

        ...mapState('auth', [
            'isLoggedIn'
        ]),

        ...mapGetters({
            getSmsSetting: 'settings/getSmsSetting',
            getSmsSettingMessage: 'settings/getSmsSettingMessage',
            getEditProduct: 'cart/getEditProduct'
        })
    },
    mounted: function() {
        this.init();
        //resetting vehicle
        this.setVehicle(null);
    },
    watch: {
        'plateNo': function(newVal, oldVal) {
            this.plateNo = newVal.toUpperCase();
            this.plateNo = this.plateNo.replace(/\W/g, '');

            if(!this.destAutocomplete) {
                this.showAutocomplete = true;
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if(from.name != 'cart') {
                vm.resetEditProduct();
            }
        });
    },
    beforeDestroy() {
        this.resetEditProduct();
    },
    methods: {
        hasChasis() {
            if(!this.vehicle._chasisNo) {
                this.noChasisOnLoad = true;
            }
            else {
                this.chasisNo = this.vehicle._chasisNo;
            }
        },

        ...mapActions('countries', {
            actionGetCountries: 'getCountries'
        }),

        ...mapActions('tollCategories', [
            'getCategory'
        ]),

        ...mapActions('vehicles', [
            'getVehicle',
            'addVehicle'
        ]),

        ...mapMutations('vehicles', [
            'setVehicle'
        ]),

        ...mapActions('orders', [
            'postOrder'
        ]),

        ...mapActions('cart', {
            addToCartAction: 'addToCart',
            resetEditProduct: 'resetEditProduct'
        }),

        async init() {
            this.loading = true;
            await this.getCountries();

            try {
                await this.getCategory(this.id);

                if(this.carId) {
                    await this.getVehicle(this.carId);
                    this.hasChasis();
                }

                this.checkIfEditProductAndInit();

                this.loading = false;
            } catch (err) {
                this.loading = false;
                this.$dialog.alert({
                    'message':  this.$t('toll_category_error_loading_car'),
                    'confirmButtonText': this.$t('btn_i_understand')
                });
            }
        },

        toggle(id){
            $(`#${id}`).toggle()
        },

        checkIfEditProductAndInit() {
            if(this.getEditProduct) {
                let key = this.category.prices.findIndex((price) => {
                    return price.id == this.getEditProduct.priceId;
                });
                this.choosePasses(key);

                this.plateNo = this.getEditProduct.plateNo;
                this.chasisNo = this.getEditProduct.chasisNo;
                this.fromDate = this.getEditProduct.fromDate;
                this.country = this.getEditProduct.country;
                this.reason = this.getEditProduct.reason;
                this.sms_confirm_notification = this.getEditProduct.sms_confirm_notification;
            }
        },

        async getCountries() {
            if(this.countries == null) {
                try {
                    let response = await this.actionGetCountries();
                } catch (error) {
                    this.$dialog.alert({
                        'message':  this.$t('toll_category_error_loading_country'),
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            }
        },

        validate() {

            this.clearErrors(this.errorMsgs);

            var ok = true;

            if(this.id != 1 || this.passes != 0) {
                if(!this.chasisNo) {
                    ok = false;
                    this.errorMsgs.chasisNo = this.$t('mandatory');
                }
                else if(!this.validateChasisNo(this.chasisNo)) {
                    ok = false;
                    this.errorMsgs.chasisNo = 'Invalid';
    
                    if(this.carId) {
                        this.noChasisOnLoad = true;
                    }
                }
            }

            if(!this.vehicle) {

                if(!this.plateNo) {
                    ok = false;
                    this.errorMsgs.plateNo = this.$t('mandatory');
                }

                let plateNoOk = this.validatePlateNo(this.plateNo, this.country);

                if(!plateNoOk) {
                    ok = false;
                    this.errorMsgs.plateNo = this.$t('invalid_plate_number_message');
                }
            }

            return ok;
        },

        addToCart() {

            if(!this.validate()) return false;

            if(!this.vehicle) {

                let car = {
                    _plateNo: this.plateNo,
                    _chasisNo: this.chasisNo,
                    _country: this.country,
                    _reason: this.reason,
                    _category: 0,
                    _category_TPF: this.id
                };

                this.setVehicle(car);
            }
            else {

                if(!this.vehicle._chasisNo) {
                    this.vehicle._chasisNo = this.chasisNo;
                }

                this.plateNo = this.vehicle._plateNo;
                this.chasisNo = this.validateChasisNo(this.vehicle._chasisNo) ? this.vehicle._chasisNo : this.chasisNo;
                this.country = this.vehicle._country;
                this.reason = this.vehicle._reason;
            }

            this.insertToCart();
        },

        async insertToCart() {
            let product = {
                type: 'toll',
                category: parseInt(this.id),
                quantity: this.category.prices[this.passes].valability.quantity,
                productName: this.category.prices[this.passes].valability.description,
                productId: this.category.prices[this.passes].valability.id,
                priceId: this.category.prices[this.passes].id,
                plateNo: this.plateNo,
                vehicleId: this.vehicle.id ? this.vehicle.id : 0,
                chasisNo: this.chasisNo,
                country: this.country,
                price: this.category.prices[this.passes].value_ron,
                reason: this.reason,
                category_name: this.category.title,
                category_description: this.category.desc,
                sms_confirm_notification: this.sms_confirm_notification
            };

            this.addToCartAction(product);
            this.$router.push({ name: "cart"})
        },

        choosePasses(key) {
            this.passes = key
            this.selected = true
            this.form_visible = true
        },

        setSearchedVehicle(vehicle) {
            this.plateNo = vehicle._plateNo;
            this.chasisNo = vehicle._chasisNo;
            this.country = vehicle._country;
            this.showAutocomplete = false;
        },

        destroyAutocomplete() {
            this.destAutocomplete = true;
            setTimeout(() => {
                this.destAutocomplete = false;
            }, 100);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    #form-1 {
        background-color: #FFFEFD;
        border-radius: 6px;
        padding: 50px;
        margin-bottom: 40px;

        @media only screen and (max-width: 768px) {
            padding: 50px 20px;
        }
    }

    .form-wrapper{
        background-color: #FFFEFD;
        border-radius: 6px;
        margin-top: 36px;
        padding: 50px;
        margin-bottom: 40px;
    }

    .purchase-wrapper {
        padding-bottom: 6px;

        h1 {

            font-weight: 900;
            font-size: 54px;
            margin-top: 87px;
        }
    }

    .card-valability {
         cursor: pointer;
    }
    .card{
        position: relative !important;
        border: 1px solid #0F2443 !important;
        border-radius: 3px !important;
        text-align: initial;
        padding: 19px;
        span {

            font-weight: bold;
            font-size: 22px;
        }
        .margin-minus{
            top: -14px;
            right: -16px;
        }
        &:hover{
            border: 3px solid #0F2443 !important;

            &:not(.card-primary) {
                padding: 17px;
            }

            .margin-minus{
                top: -14px;
                right: -16px;
            }
        }
    }

    .card-primary {
        padding: 17px;
        border: 3px solid #0F2443 !important;
        border-radius: 3px !important;
    }

    .auto-rov-catA{
        background-color: #EEEDEC;
        border-radius: 4px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 26px;
        padding-right: 26px;
        font-weight: 600;
        margin-bottom: 40px;

        .txt {
            margin-left: 17px;
        }
        .cat-icon {
            height: 45px;
            width: 55px;
        }
        .align-center{
            align-items: center;
        }
    }
    .btn-purple{
        width: 200px;
        height: 60px;
        font-size:18px;
        margin-bottom: 50px;
    }

    .cat1-icon {
        background-image:url('../media/icons/tpfColor/cat1.svg');
    }
    .cat2-icon {
        background-image:url('../media/icons/tpfColor/cat2.svg');
    }
    .cat3-icon {
        background-image:url('../media/icons/tpfColor/cat3.svg');
    }
    .cat4-icon {
        background-image:url('../media/icons/tpfColor/cat4.svg');
    }
    .cata-icon {
        background-image:url('../media/icons/erovColor/catA.svg');
    }

    .form {
        .container {
            padding: 0;
        }
        padding-bottom: 130px;
    }

    @media only screen and (max-width: 768px) {
        .no-padding-mobile {
            padding: 0;
        }
        
        #form-1 {
            padding: 15px;
        }
    }

    // MEDIA QUERIES
    @media only screen and (max-width: 600px) {
        .form-wrapper{
            background-color: #FFFEFD;
            border-radius: 6px;
            margin-top: 36px;
            padding: 30px 15px;
            margin-bottom: 40px;
            margin-left: -15px;
            margin-right: -15px;
        }

        .section {
            background-color: #FAF9F6;
            background-position: center;
            background-size: cover;
            padding-bottom: 0;
            .purchase-wrapper{
                h1 {

                    font-weight: 900;
                    font-size: 54px;
                    margin-top: 87px;
                }
            }
        }
        .action-button {
            padding: 0 15px;
        }
    }

</style>
